<template>
  <div class="board-section">
    <div class="d-flex justify-space-between align-center mb-3">
      <div class="subtitle-1 font-weight-medium" style="line-height: inherit">{{ title }}</div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'BoardSection',
  components: {

  },
  props: ["title"],
  data: () => ({

  }),
  methods: {

  },
  mounted() {

  }
}
</script>

<style>
.board-section {
  display: flex;
  position: relative;
  flex-direction: column;
  box-sizing: border-box;
  width: 280px;
  max-height: 100%;
  padding: 0;
  margin-right: 12px;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 10px;
  min-height: 33%;
}
</style>